module.exports = __webpack_public_path__ + "static/media/3_screen.d1b6e39e.png";